import type { User, Organization } from '@awang/shared-types'
import { client } from './client'

export interface LoginRequest {
  email: string
  password: string
}

export interface AuthResponse {
  user: User
  organization: Organization | null
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
}

export async function login(data: LoginRequest): Promise<AuthResponse> {
  return client.post<AuthResponse>('/identity/login', data)
}

export async function getMe(): Promise<User> {
  return client.get<User>('/identity/me')
}

export async function logout(refreshToken: string): Promise<{ message: string }> {
  return client.post<{ message: string }>('/identity/logout', { refresh_token: refreshToken })
}
